import MainHeading from "../typeComponents/MainHeading";
import TextBlock from "../typeComponents/TextBlock";
import Paragraph from "../typeComponents/Paragraph";
import { Box } from "@mui/material";
import CureLogoCleanVector from "../images/CURE_logo_clean_vector.svg";

const SayHi = () => {
  return (
    <>
      <TextBlock>
        <MainHeading>Come Meet CURE!</MainHeading>
        <Box sx={{ width: { xs: "45vw", md: "24vw" }, padding: "10px" }}>
          <img src={CureLogoCleanVector} alt="CURE Montreal Logo" />
        </Box>{" "}
        {/* This is wordy so am also considering simply naming this page 'Get Involved!' but I feel like that's not sufficiently differentiated from the 'Join the Board!' page... */}
        {/*
        Who are we looking for?
        - student! ☆☆☆
        - on campus regularly
        - someone who cares about theirs and others' student experiences
        - natural leader, (not necessarily formally a leader)
        Possible ways someone could get involved
        - volunteering
          - postering
          - flyering
          - house meeting
        - talking
          - learning more about us
          - telling us what matters to them (what they'd like us to help with)
        note: we would want to first talk to them and possibly in that conversation talk about volunteering.
        notes:
        More circumspect about campaign
        not front and center!
        by the end of the week
        (clear things out then too)
      
        do like trying to get more involved
        We want to get to know you!
        also have a pragragraph about fee levy campaign
        would involved be interested in hearing about / helping
        we want to get to know you front and center!
        campaign off the bat is too much of an ask
        then later we convert them muahaha
        as part of getting to know us, we'd be happy to get u involved
        if you're a natural leader, help get you talking to other people
        **lowest stakes stuff**
        name and email
        individual student or organization
        shorter or longer meeting
        (learn about us or talk about what amtters to me)
        morning afternoon or evening in general (further figuring out by email?)
        interested in getting involved, hearing about, or not sure about campaign
        bullet points as to what amtters to you on campus
        */}
        <Paragraph>
          We want to hear from other student organizations, as well as students
          themselves! Currently, we're also considering a possible upcoming fee
          levy campaign or other fundraising with students and would love your
          perspective on what you'd want to see from that! If you're a student,
          we would love to hear from you!
        </Paragraph>
        <Paragraph>
          If you're a current student on campus, someone who cares about theirs
          and other students' experience, or maybe just someone who's curious
          about us and what we do, we invite you to make an appointment with us!
          We want to hear your questions about CURE, what matters to you about
          campus life that we could potentially help with!
        </Paragraph>
        {/* <Paragraph>
          We'd also love to hear if you're interested in helping us with our fee
          levy campaign! We'd greatly appreciate any help with postering or
          flyering.
        </Paragraph> */}
        <Paragraph>
          If any of this interests you, fill out the form below! Thanks so much!
        </Paragraph>
        <Paragraph>
          We also now have the power to meet in OUR MINECRAFT SERVER!!! So check
          that out if it interests you. :)
        </Paragraph>
      </TextBlock>
      <div>
        <iframe
          title="Come Meet Cure! - Form"
          src="https://docs.google.com/forms/d/e/1FAIpQLSelhkoKX9mC_AjivTULowhKqLMMKpp2QXZKGsJJuPV8TYDNhw/viewform?embedded=true"
          width="100%"
          height="1894"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >
          Loading…
        </iframe>
      </div>
    </>
  );
};
export default SayHi;
